import type { GalleryMedia } from "../api/contentful";

const preloadedUrls = new Set<string>();

export function getGalleryLightboxSrc(item: GalleryMedia): string {
  if (item.type === "video") return item.url;
  return item.lightboxUrl || item.url;
}

/** Warm the browser cache for a gallery image URL (no-op if already requested). */
export function preloadGalleryImage(url: string): void {
  if (!url || preloadedUrls.has(url)) return;
  preloadedUrls.add(url);

  const img = new Image();
  img.decoding = "async";
  img.src = url;
}

export function preloadGalleryNeighbors(
  media: GalleryMedia[],
  centerIndex: number,
  radius = 3,
): void {
  if (!media.length) return;

  for (let offset = -radius; offset <= radius; offset += 1) {
    const index = (centerIndex + offset + media.length) % media.length;
    const item = media[index];
    if (item?.type === "image") {
      preloadGalleryImage(getGalleryLightboxSrc(item));
    }
  }
}

export function preloadGallerySection(media: GalleryMedia[]): void {
  media.forEach((item) => {
    if (item.type === "image") {
      preloadGalleryImage(getGalleryLightboxSrc(item));
    }
  });
}
